import { createApp } from "vue";
import App from "./App.vue";
import store from "./store/calculator.store";

import { createHead } from "@vueuse/head";

import Notifications from "@kyvg/vue3-notification"; // Vue 3 compatible notifications
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

async function waitForMountAndInit() {
	const mountEl = document.getElementById("quotation_calculator_inject");
	if (mountEl) {
		await store.dispatch("loadPricelistFromApi");

		// Create Vue app instance
		const app = createApp(App);

		// Head/meta manager
		const head = createHead();
		app.use(head);
		app.use(store);

		// Global component
		app.component("v-select", vSelect);

		// Notifications
		app.use(Notifications);

		// Mount
		app.mount("#quotation_calculator_inject");
	} else {
		setTimeout(waitForMountAndInit, 100);
	}
}
waitForMountAndInit();
